import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getCurrencies(action: Action) {
    try {
        const currencies = yield call(() =>
            configurationsAPI.getCurrencies({
                subsidiaryId: action.payload.subsidiaryId
            })
        );

        yield put({
            type: ConfigurationsActionTypes.GET_CURRENCIES_SUCCESS,
            payload: currencies.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Currencies.");

        yield put({
            type: ConfigurationsActionTypes.GET_CURRENCIES_FAIL,
            payload: e
        });
    }
}

export function* getCurrenciesWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_CURRENCIES,
        getCurrencies
    );
}
